import api from "../apiClient";

// Service Catalog — offerings are the templates a plan/visit inherits from.
// Backed by the now-writable OfferingViewSet (services_app).

export const listOfferings = (params = {}) =>
  api.get("/services/offerings/", { params });

export const createOffering = (payload) =>
  api.post("/services/offerings/", payload);

export const updateOffering = (id, payload) =>
  api.patch(`/services/offerings/${id}/`, payload);

export const deleteOffering = (id) =>
  api.delete(`/services/offerings/${id}/`);

// Service types for the assign dropdown (tenant-scoped).
export const listServiceTypes = (params = {}) =>
  api.get("/scheduling/service-types/", { params });

// An offering is "complete" (ready to prefill a booking) once it has a service
// type. Recurring offerings additionally power plans. These two derived flags
// drive the Catalog's teaching states — surfaced, not discovered at booking time.
export const offeringCompleteness = (offering) => ({
  hasServiceType: Boolean(offering?.service_type),
  isRecurring: Boolean(offering?.is_recurring),
});
